import type { GetOverlayStyleProps } from "./image-with-data.type";
import type { CSSProperties } from "react";

export const getOverlayStyle = ({
  containerSize: container,
  imageNaturalSize: image,
}: GetOverlayStyleProps): CSSProperties | undefined => {
  if (!container || !image) return undefined;

  const imageRatio = image.width / image.height;
  const containerRatio = container.width / container.height;

  let displayWidth, displayHeight;

  if (containerRatio > imageRatio) {
    displayHeight = container.height;
    displayWidth = container.height * imageRatio;
  } else {
    displayWidth = container.width;
    displayHeight = container.width / imageRatio;
  }

  const offsetX = (container.width - displayWidth) / 2;
  const offsetY = (container.height - displayHeight) / 2;

  return {
    position: "absolute",
    left: offsetX,
    top: offsetY,
    width: displayWidth,
    height: displayHeight,
  };
};
